import { Navigate, useParams } from "react-router-dom";

export function LegacyStoreRedirect() {
  const { restaurant } = useParams();
  return <Navigate to={`/food/stores/${restaurant}`} replace />;
}

export function LegacyAddressRedirect() {
  return <Navigate to="/food?address=1" replace />;
}
